// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".accordion-control[data-v-24f135d0]{width:100%;text-align:right;margin-bottom:4px;padding-right:3px}.accordion-control .accordion-button[data-v-24f135d0]{transition:.1s ease-in-out;padding:18px 13px 12px;margin-left:2px;background-color:#e9eaec}.accordion-control .accordion-button[data-v-24f135d0]:hover{cursor:pointer}.accordion-control .accordion-button--down[data-v-24f135d0]{background-color:#91959e}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
